 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLCH00A_TITLE from '@/components/xhtml/ch00a_title'
 import XHTMLCH00C_DEDICATION from '@/components/xhtml/ch00c_dedication'
 import XHTMLCH00D_CONTENT from '@/components/xhtml/ch00d_content'
 import XHTMLCH00E_FOREWORD from '@/components/xhtml/ch00e_foreword'
 import XHTMLCH00F_INTRODUCTION from '@/components/xhtml/ch00f_introduction'
 import XHTMLCH00G_PART1 from '@/components/xhtml/ch00g_part1'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05_PART02 from '@/components/xhtml/ch05_part02'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLCH06_BM00 from '@/components/xhtml/ch06_bm00'
 import XHTMLCH07_BM01 from '@/components/xhtml/ch07_bm01'
 import XHTMLCH08_BM02 from '@/components/xhtml/ch08_bm02'
 import XHTMLCH09_BM03 from '@/components/xhtml/ch09_bm03'
 import XHTMLCH10_BM04 from '@/components/xhtml/ch10_bm04'
 import XHTMLCH11_INDEX from '@/components/xhtml/ch11_index'
 import XHTMLCH12_BM05 from '@/components/xhtml/ch12_bm05'
 import XHTMLCH13_BM06 from '@/components/xhtml/ch13_bm06'
 import XHTMLCH14_BM07 from '@/components/xhtml/ch14_bm07'
 import XHTMLCH00B_COPYRIGHT from '@/components/xhtml/ch00b_copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/ch00d_content",
 			"name" : "xhtml/ch00d_content",
 			"component" : XHTMLCH00D_CONTENT
 		},
 		{
 			"path" : "/xhtml/ch00e_foreword",
 			"name" : "xhtml/ch00e_foreword",
 			"component" : XHTMLCH00E_FOREWORD
 		},
 		{
 			"path" : "/xhtml/ch00f_introduction",
 			"name" : "xhtml/ch00f_introduction",
 			"component" : XHTMLCH00F_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/ch00g_part1",
 			"name" : "xhtml/ch00g_part1",
 			"component" : XHTMLCH00G_PART1
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js